import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HttpClientModule} from "@angular/common/http";

import {Service} from "./service";


@NgModule({
	imports: [
		CommonModule,
		HttpClientModule
	],
	providers: [
		Service
	]
})

export class RestModule {
	/*
	constructor(@Optional() @SkipSelf() parentModule: RestModule) {
		if (parentModule) {
			throw new Error('RestModule is already loaded. Import it in the AppModule only');
		}
	}
	*/

	constructor() {

	}

	// static forRoot(config?: {}): ModuleWithProviders {
	// 	return {
	// 		ngModule: PapiModule,
	// 		providers: [
	// 			{provide: ApiModule, useValue: ApiModule }
	// 		]
	// 	};
	// }
}
